import React, { Component } from 'react'
import {
  Link
} from 'react-router-dom'

class Classes extends Component {
  renderChildClasses() {
    const collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'})
    const classes = Object.keys(this.props.class.classes).sort(collator.compare)

    return classes.map((klass) => {
      const url = `${window.location.pathname}/${klass}`
      return (
        <div key={klass}>
          <Link to={url}>
            {klass}
          </Link>
        </div>
      )
    })
  }

  render() {
    const classes = this.renderChildClasses()

    return (
      <div>
        <h3>Child Classes</h3>
        {classes}
      </div>
    )
  }
}

export default Classes



// WEBPACK FOOTER //
// ./src/Classes.js